import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import {
	Coin98WalletAdapter,
	CoinbaseWalletAdapter,
	MathWalletAdapter,
	PhantomWalletAdapter,
	SolflareWalletAdapter,
	SpotWalletAdapter,
	TrustWalletAdapter,
	WalletConnectWalletAdapter,
} from '@solana/wallet-adapter-wallets';
import { DRIFT_WALLET_CONNECT_PROJECT_ID } from './constants';
import Env from '../environmentVariables/EnvironmentVariables';

/**
 * A list of wallets to display in the wallet connection list.
 *
 * On SAGA the mobile wallet adapter will be added to the list automatically.
 *
 * The Wallet Provider should also be smart enough to add any other detected wallets to the list too.
 */
export const DRIFT_WALLET_PROVIDERS = [
	new PhantomWalletAdapter(),
	new SolflareWalletAdapter(),
	new CoinbaseWalletAdapter(),
	new WalletConnectWalletAdapter({
		network:
			Env.sdkEnv === 'mainnet-beta'
				? WalletAdapterNetwork.Mainnet
				: WalletAdapterNetwork.Devnet,
		options: {
			relayUrl: 'wss://relay.walletconnect.com',
			// example WC app project ID
			projectId: DRIFT_WALLET_CONNECT_PROJECT_ID,
			metadata: {
				name: 'Drift Protocol',
				description:
					'Drift is the leading perpetuals DEX on Solana with the most CEX-like trader experience',
				url: 'https://app.drift.trade/',
				icons: [
					'https://drift-public.s3.eu-central-1.amazonaws.com/DriftLogoCircular.png',
				],
			},
		},
	}),
	new SpotWalletAdapter(),
	new TrustWalletAdapter(),
	new MathWalletAdapter(),
	new Coin98WalletAdapter(),
];
